<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useSkeleton } from '@/modules/core/composables/useSkeleton'
import OtherEntityNav from '../components/other-entity-nav.vue'
import OtherEntityHeader from '../components/other-entity-header.vue'
import TheLayout from '@/modules/shared/layouts/the-layout.vue'
import NoteTimeline from '../components/notes/note-timeline.vue'
import { useNoteStore } from '../stores/note-store'

const noteStore = useNoteStore()
const route = useRoute()

const { other_entity_id, slug } = route.params as { other_entity_id: string; slug: string }

const { skeleton, hideSkeleton, showSkeleton } = useSkeleton()

onMounted(async () => {
  showSkeleton()
  await noteStore.fetchNotes('funding-entities', other_entity_id, { slug })
  hideSkeleton()
})
</script>

<template>
  <TheLayout>
    <OtherEntityHeader />
    <OtherEntityNav />
    <div v-if="skeleton" class="py-8 text-center text-sm text-gray-500">Loading...</div>
    <NoteTimeline v-else commentableType="funding-entities" :commentableId="other_entity_id" permission="admins" />
  </TheLayout>
</template>
